// slick初期化の共通関数を定義
function initializeSlickSlider() {
  $('.custom-slider').each(function () {
    // すでに初期化済みの場合は一度破棄する
    if ($(this).hasClass('slick-initialized')) {
      $(this).slick('unslick');
    }
    // slickの初期化
    $(this).slick({
      autoplay: true,             // 自動再生
      infinite: true,             // ループ
      arrows: true,               // 矢印表示
      variableWidth: true,        // 可変幅
      centerMode: true,           // センターモード
      speed: 500,                 // スライド速度
      slidesToShow: 3,            // 表示スライド数
      slidesToScroll: 1,          // 1回のスクロールで移動するスライド数
      prevArrow: '<div class="slick-prev"></div>',
      nextArrow: '<div class="slick-next"></div>',
      dots: true,                 // ドットナビゲーション表示
      responsive: [
        {
          breakpoint: 769,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 426,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  });
}

// 通常ページロード時にslickを初期化
$(document).ready(function () {
  initializeSlickSlider();
});

// Shopifyのテーマエディタでセクション読み込み・編集時にslickを再初期化
document.addEventListener('shopify:section:load', function () {
  setTimeout(initializeSlickSlider, 1000); // 遅延を延長
});
document.addEventListener('shopify:section:reorder', function () {
  setTimeout(initializeSlickSlider, 1000);
});
document.addEventListener('shopify:block:select', function () {
  setTimeout(initializeSlickSlider, 1000);
});
document.addEventListener('shopify:block:deselect', function () {
  setTimeout(initializeSlickSlider, 1000);
});

// Shopifyのテーマエディタでセクションがアンロードされるときはslickを破棄
document.addEventListener('shopify:section:unload', function () {
  $('.custom-slider').slick('unslick');
});
